"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useClampedOverflow2 = require("@common/hooks/use-clamped-overflow");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _collapsible = require("@design/ui/collapsible");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function CommentPreview(_ref) {
  var text = _ref.text,
    actions = _ref.actions;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useClampedOverflow = (0, _useClampedOverflow2.useClampedOverflow)(text, isExpanded),
    clampedRef = _useClampedOverflow.clampedRef,
    canExpand = _useClampedOverflow.canExpand;
  function handleTextClick(e) {
    var _window$getSelection$, _window$getSelection;
    if (!canExpand) return;
    var target = e.currentTarget;
    var rect = target.getBoundingClientRect();
    var scrollbarWidth = target.offsetWidth - target.clientWidth;
    var clickedOnScrollbar = e.clientX > rect.right - scrollbarWidth;
    var selectedText = (_window$getSelection$ = (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.toString()) !== null && _window$getSelection$ !== void 0 ? _window$getSelection$ : "";
    var hasSelection = selectedText.length > 0;
    if (!clickedOnScrollbar && !hasSelection) {
      setIsExpanded(function (prev) {
        return !prev;
      });
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.Collapsible, {
    open: isExpanded,
    onOpenChange: setIsExpanded,
    asChild: true,
    "data-sentry-element": "Collapsible",
    "data-sentry-component": "CommentPreview",
    "data-sentry-source-file": "CommentPreview.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
      size: "sm",
      className: "mb-2",
      "data-sentry-element": "Card",
      "data-sentry-source-file": "CommentPreview.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
        "data-sentry-element": "CardContent",
        "data-sentry-source-file": "CommentPreview.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ref: clampedRef,
          onClick: handleTextClick,
          className: (0, _utils.cn)("whitespace-pre-wrap", isExpanded ? "max-h-[calc(100vh-335px)] overflow-auto" : "line-clamp-4", canExpand && "cursor-pointer"),
          children: text
        })
      }), (canExpand || actions) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardFooter, {
        className: "gap-2",
        children: [canExpand && /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.CollapsibleTrigger, {
          asChild: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "link",
            size: "xs",
            children: isExpanded ? "Show less" : "Show more"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ml-auto flex items-center gap-1",
          children: actions
        })]
      })]
    })
  });
}
var _default = exports.default = CommentPreview;